
export function validateUserIdentifier(value: string, typeOfAddingnewuser: 'Email' | 'uuid' | '') {
  let errorMessage; // Default no error

  if (typeOfAddingnewuser === 'Email') {

    // Regex to validate the general format of an email
    const generalEmailRegex =  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // Regex to validate specific vially domains
    const viallyEmailRegex = /^[a-zA-Z0-9._-]+@vially\.(io|ie)$/;

    // Check if the email is in a valid format
    if (!generalEmailRegex.test(value)) {
      errorMessage = "Please enter a valid email address.";
    }
    // Check if it is a vially.io or vially.ie email
    // if (!value.endsWith('@vially.io') && !value.endsWith('@vially.ie')) {
    //   errorMessage = "Only Verified Vially Accounts are Allowed";
    // }
  } else if (typeOfAddingnewuser === 'uuid') {
    // Example regex for tenant ID (customize as needed)
    const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    if (!uuidRegex.test(value)) {
      errorMessage = "Please enter a valid tenant ID (format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx where x is a hexadecimal digit).";
    }
  }
  return errorMessage;
}


export const handleNaN = (number: number | null | undefined): number => {
  return Number.isFinite(number) ? number as number : 0;
};